import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useSelector } from 'react-redux';

import { SPINE_ASSETS } from '../../../assets/spine';
import SpineAnimation from '../../../components/SpineAnimation';
import { RootState } from '../../../store';
import { useDevice } from '../../../utils/hooks/useDevice';

const DEFAULT_SCALE = 1;
const SUPPORTED_LOADER_SKINS = new Set(['bg', 'en', 'fr', 'ru', 'tr']);
const DISPLAY_LOADER_WIDTH = 283;
const DISPLAY_LOADER_HEIGHT = 144;
const NATIVE_RENDER_WIDTH = 1000;
const NATIVE_RENDER_HEIGHT = 700;

const AnimatedLoader = ({ scale = DEFAULT_SCALE }: { scale?: number }) => {
	const { isWeb } = useDevice();
	const { skeletonFile, atlasFile, animations } = SPINE_ASSETS.loader;
	const langCode = useSelector((state: RootState) => state.i18n.langCode);
	const skin = SUPPORTED_LOADER_SKINS.has(langCode) ? langCode : 'en';
	const width = DISPLAY_LOADER_WIDTH * scale;
	const height = DISPLAY_LOADER_HEIGHT * scale;
	const nativeScale = Math.min(width / NATIVE_RENDER_WIDTH, height / NATIVE_RENDER_HEIGHT);

	return (
		<View style={[styles.wrapper, { width, height }]}>
			<View
				style={[
					styles.animationContainer,
					{
						width: isWeb ? width : NATIVE_RENDER_WIDTH,
						height: isWeb ? height : NATIVE_RENDER_HEIGHT,
						transform: isWeb ? undefined : [{ scale: nativeScale }],
					},
				]}
			>
				<SpineAnimation
					loop
					playing
					animationName={animations?.idle}
					skin={skin}
					skeletonFile={skeletonFile}
					atlasFile={atlasFile}
					width={isWeb ? width : NATIVE_RENDER_WIDTH}
					height={isWeb ? height : NATIVE_RENDER_HEIGHT}
				/>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	wrapper: {
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'visible',
	},
	animationContainer: {
		overflow: 'visible',
		alignItems: 'center',
		justifyContent: 'center',
	},
});

export default AnimatedLoader;
